// The extension bridge — copied from flight-processor/index.html (lines 2273-2290).
//
// This is the ENTIRE relationship between this website and Smiles. The extension does all the
// real work; this just posts a message and waits. The extension has no idea what framework the
// page is written in, which is why porting this site to React cannot touch the booking system.
//
// For any of this to work, the extension's manifest.json must list this site's domain under
// host_permissions AND in the bridge.js content_scripts block. Without that, nothing arrives.

let bridgeReady = false;
const pending = {};
let reqId = 0;
let currentSearchId = null;

window.addEventListener('message', (e) => {
  if (e.source !== window || !e.data) return;
  if (e.data.__ymBridge === 'ready') {
    bridgeReady = true;
    const v = document.getElementById('ymcVer');
    if (v && e.data.version) v.textContent = 'ext v' + e.data.version;
  }
  if (e.data.__ymRes === 'search' && pending[e.data.id]) { pending[e.data.id](e.data); delete pending[e.data.id]; }
});

try { window.postMessage({ __ymPing: true }, '*'); } catch (e) {}

export const isBridgeReady = () => bridgeReady;

export function searchViaBridge(params) {
  return new Promise((resolve) => {
    const id = ++reqId;
    currentSearchId = id;
    pending[id] = resolve;
    window.postMessage({ __ymReq: 'search', id, params }, '*');
    setTimeout(() => { if (pending[id]) { delete pending[id]; resolve({ ok: false, error: 'timeout' }); } }, 180000);
  });
}

export function stopSearch() {
  if (currentSearchId && pending[currentSearchId]) { pending[currentSearchId]({ ok: false, aborted: true }); delete pending[currentSearchId]; }
  try { window.postMessage({ __ymReq: 'abort' }, '*'); } catch (e) {}
}
